import { Component, Inject } from '@angular/core'
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogModule,
} from '@angular/material/dialog'
import { FormGroup, ReactiveFormsModule } from '@angular/forms'
import { CommonModule } from '@angular/common'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'

@Component({
  selector: 'app-followup-dialog',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
  ],
  templateUrl: './followup-dialog.component.html',
  styleUrls: ['./followup-dialog.component.css'],
})
export class FollowupDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<FollowupDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { followUpForm: FormGroup; mode: string }
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    if (this.data.followUpForm.valid) {
      this.dialogRef.close(this.data.followUpForm.value);
    }
  }
}
